/** WhatsApp-like compact time (12h, lowercase am/pm). */
export function formatWaChatTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (!Number.isFinite(d.getTime())) return "";
  return d
    .toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", hour12: true })
    .replace(" AM", " am")
    .replace(" PM", " pm");
}
